/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Button} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'

const CartCta = (props) => {
    return (
        <Button as={Link} to="/checkout" width={'100%'} variant="primary" {...props}>
            <FormattedMessage
                defaultMessage="Proceed to Secure Checkout"
                id="cart_cta.link.checkout"
            />
        </Button>
    )
}

export default CartCta
